module.exports = __webpack_public_path__ + "img/thumbnail_Moose_f_albino.4a5f7a4d.png";